import { Component, computed, inject, input } from '@angular/core';
import { IMAGE_ORIGIN } from '@ird/ng-core';

@Component({
  selector: 'shared-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
})
export class ImageComponent {
  public imageSrc = input.required<string>();
  public imageClassName = input<string>('');
  protected addOrigin = input(false);
  protected addUrl = input(false);

  protected readonly imageOrigin = inject(IMAGE_ORIGIN);
  protected imageUrl = computed(() => {
    let imageOrigin = '';

    if (this.addOrigin()) {
      imageOrigin = this.imageOrigin || '';
    }

    if (this.addUrl()) {
      return `url(${imageOrigin}${this.imageSrc()})`;
    }

    return imageOrigin + this.imageSrc();
  });
}
